/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unnamed-components */
'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import Logo from '../Logo';
import { navigateTo } from '../../util/History';
import { getSearchParams } from '../../util/Urls';
import LanguageSwitcher from '../LanguageSwitcher';
import { ROOT } from '../../constants/Paths';

const navigateHome = () => navigateTo(`${ROOT}${getSearchParams()}`);

const Title = () => /*#__PURE__*/_jsx("div", {
  className: "title",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "meta.title"
  })
});

export default (() => {
  return /*#__PURE__*/_jsxs("div", {
    className: "main-toolbar",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "logo-left",
      children: [/*#__PURE__*/_jsx(Logo, {
        onClick: navigateHome
      }), /*#__PURE__*/_jsx(Title, {})]
    }), /*#__PURE__*/_jsx(LanguageSwitcher, {})]
  });
});